import React from "react";
import Button from "@material-ui/core/Button";
import styled from "styled-components";
import AddIcon from "@material-ui/icons/Add";
import { CircularProgress } from "@material-ui/core";

const StyledPrimaryButton = styled(Button)`
  &.MuiButton-root {
    background: #2563eb;
    color: #fff;
    font-size: 13px;
    line-height: 18px;
    border-radius: 8px;
    height: 40px;
    font-weight: 800;
    text-transform: none;
    box-shadow: 0 2px 8px 0 rgba(37, 99, 235, 0.08);
    transition:
      background 0.18s,
      box-shadow 0.18s;
    &:hover {
      background: #174ea6;
      box-shadow: 0 4px 16px 0 rgba(37, 99, 235, 0.13);
    }
    &:active {
      background: #174ea6;
      box-shadow: 0 2px 8px 0 rgba(37, 99, 235, 0.1);
    }
  }
`;

const StyledDisabledButton = styled(Button)`
  &.MuiButton-root {
    background: #d1d1d1;
    color: #7f7f7f;
    font-size: 13px;
    line-height: 18px;
    border-radius: 8px;
    height: 40px;
    font-weight: 800;
    text-transform: none;
    &:hover {
      background: #d1d1d1;
    }
  }
`;

const PrimaryButton = React.forwardRef(
  (
    {
      children,
      hideIcon,
      disabled,
      hasIcon,
      icon,
      hasCustomLabel,
      apiLoader,
      ...rest
    },
    ref,
  ) => {
    return (
      <>
        {disabled ? (
          <StyledDisabledButton
            startIcon={
              hideIcon === true ? (
                <></>
              ) : hasIcon ? (
                icon
              ) : (
                <AddIcon style={{ color: "#8d8d8d" }} />
              )
            }
            disabled={disabled}
            ref={ref}
            {...rest}
          >
            {apiLoader && (
              <CircularProgress
                color="#0a0a29"
                size={14}
                style={{ marginRight: 4 }}
              />
            )}
            {hasCustomLabel ? children : disabled ? "Please Wait" : children}
          </StyledDisabledButton>
        ) : (
          <StyledPrimaryButton
            startIcon={
              hideIcon === true ? (
                <></>
              ) : hasIcon ? (
                icon
              ) : (
                <AddIcon style={{ color: "#fff" }} />
              )
            }
            disabled={disabled}
            ref={ref}
            {...rest}
          >
            {apiLoader && (
              <CircularProgress
                color="#0a0a29"
                size={14}
                style={{ marginRight: 4 }}
              />
            )}
            {hasCustomLabel ? children : disabled ? "Please Wait" : children}
          </StyledPrimaryButton>
        )}
      </>
    );
  },
);

export default React.memo(PrimaryButton);
